import { observer } from 'mobx-react-lite'
import { FormRow } from '@/components/Form'
import { NumericInputContainer } from '@/components/inputs/NumericInputContainer'
import { TextInputContainer } from '@/components/inputs/TextInputContainer'
import { AddManualInvoiceDialog } from '@/features/jobs/details/components/AddManualInvoiceDialog'
import { type AddManualInvoiceDialogViewModel } from './AddManualInvoiceDialogViewModel'

export interface AddManualInvoiceDialogContainerProps {
  vm: AddManualInvoiceDialogViewModel
}

export const AddManualInvoiceDialogContainer = observer(
  function AddManualInvoiceDialogContainer({
    vm,
  }: AddManualInvoiceDialogContainerProps) {
    return (
      <AddManualInvoiceDialog
        showing={vm.modal.showing}
        isAddPending={vm.add.pending}
        onClose={vm.modal.close}
        onAdd={vm.add}
      >
        <FormRow>
          <TextInputContainer
            model={vm}
            field="reason"
            name="reason"
            label="Reason"
            data-test="add-manual-invoice-reason"
            placeholder="e.g. Credit Card on file didn't work. Add the invoice number (INV-XXX)"
            error={vm.validation.getError('reason')}
          />
        </FormRow>

        <FormRow>
          <TextInputContainer
            model={vm}
            field="stripeId"
            name="stripeId"
            label="Stripe Id"
            data-test="add-manual-invoice-stripe-id"
            placeholder="The Stripe Charge Id (ch_XXXXXXXXXXXXXX)."
            error={vm.validation.getError('stripeId')}
          />
        </FormRow>

        <FormRow>
          <NumericInputContainer
            model={vm}
            precision={2}
            field="invoiceAmount"
            name="invoiceAmount"
            label="Invoice amount"
            testId="add-manual-invoice-amount"
            error={vm.validation.getError('invoiceAmount')}
          />
        </FormRow>
      </AddManualInvoiceDialog>
    )
  },
)
